//EXTRACTED FROM https://loading.io/css/

import React from 'react';
import './LoadingEllipses.scss';

const LoadingEllipses = () => {
  return(
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  );
}

export default LoadingEllipses;